import gsap from 'gsap';

export default function initContact() {
    if (!document.querySelector('.contact-toggle__email')) {
        return;
    }
    const emailtAnchor = document.querySelector('#contact-email');
    const phoneAnchor = document.querySelector('#contact-phone');
    document.querySelector('.contact-toggle__email').addEventListener('click', function(event) {
        const emailImage = this.querySelector('lottie-player');
        const phoneBlock = document.querySelector('.contact-toggle__phone');
        const form = this.querySelector('form');

        if (event.target.closest('.contact-open')) {
            gsap.to(emailImage, {
                height: 0,
                duration: 0.3, // Faster animation
                ease: 'power2.inOut',
                onComplete: () => {
                    this.classList.add('active');
                    phoneBlock.classList.remove('active');
                    gsap.set(emailImage, { height: 'auto' }); // Reset height after animation
                    emailtAnchor.scrollIntoView({ behavior: 'smooth' }); // Scroll to the phone section
                }
            });
        } else if (event.target.closest('.contact-close')) {
            gsap.to(form, {
                height: 0,
                duration: 0.3, // Faster animation
                ease: 'power2.inOut',
                onComplete: () => {
                    this.classList.remove('active');
                    gsap.set(form, { height: 'auto' }); // Reset height after animation
                    emailtAnchor.scrollIntoView({ behavior: 'smooth' }); // Scroll to the phone section
                }
            });
        }
    });

    if (!document.querySelector('.contact-toggle__phone')) {
        return;
    }

    document.querySelector('.contact-toggle__phone').addEventListener('click', function(event) {
        const phoneImage = this.querySelector('lottie-player');
        const emailBlock = document.querySelector('.contact-toggle__email');
        const form = this.querySelector('form');

        if (event.target.closest('.contact-open')) {
            gsap.to(phoneImage, {
                height: 0,
                duration: 0.3, 
                ease: 'power2.inOut',
                onComplete: () => {
                    this.classList.add('active');
                    emailBlock.classList.remove('active');
                    gsap.set(phoneImage, { height: 'auto' }); // Reset height after animation
                    phoneAnchor.scrollIntoView({ behavior: 'smooth' }); // Scroll to the phone section
                }
            });
        } else if (event.target.closest('.contact-close')) {
            gsap.to(form, {
                height: 0,
                duration: 0.3, 
                ease: 'power2.inOut',
                onComplete: () => {
                    this.classList.remove('active');
                    gsap.set(form, { height: 'auto' }); // Reset height after animation
                    phoneAnchor.scrollIntoView({ behavior: 'smooth' }); // Scroll to the form section
                }
            });
        }
    });

    function toggleActiveClass() {
        const emailElement = document.querySelector('.contact-toggle__email');
        const phoneElement = document.querySelector('.contact-toggle__phone');
        
        if (window.innerWidth > 1024 && !emailElement.classList.contains('active') && !phoneElement.classList.contains('active')) {
            emailElement.classList.add('active');
        }
    }

    // Check on initial load
    toggleActiveClass();

    // Check on window resize
    window.addEventListener('resize', toggleActiveClass);
}